import withScrollTo from './withScrollTo';

export default function withScrollToContent(Component) {
    return withScrollTo('.anchor-scrollToContent-top')<GetProps<typeof Component>>(Component);
}
